import { useMemo } from 'react';
import { useAppConfig } from '@/hooks/useShared';
import type { ChipColorEntry } from '@/lib/types';

export function useChipColors() {
  const { config, loading } = useAppConfig();

  const chipColors = useMemo<ChipColorEntry[]>(() => config?.chip_colors ?? [], [config]);
  const chipColorMap = useMemo(() => {
    const map = new Map<string, number>();
    for (const entry of chipColors) {
      map.set(entry.label.toLowerCase(), entry.value);
    }
    return map;
  }, [chipColors]);

  return { chipColors, chipColorMap, loading };
}
